export const directives = {
  link: {
    mounted(el, binding, vnode, prevVnode) {
      var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
      const target = (_c = (_b = (_a = binding == null ? void 0 : binding.value) == null ? void 0 : _a.target) != null ? _b : binding.arg) != null ? _c : "_self";
      const href = (_f = (_e = (_d = binding == null ? void 0 : binding.value) == null ? void 0 : _d.url) != null ? _e : binding == null ? void 0 : binding.value) != null ? _f : "#";
      const className = (_h = (_g = binding == null ? void 0 : binding.value) == null ? void 0 : _g.className) != null ? _h : "";
      const prevent = (_j = (_i = binding == null ? void 0 : binding.value) == null ? void 0 : _i.prevent) != null ? _j : true;
      const $a = document.createElement("a");
      $a.setAttribute("href", href);
      $a.setAttribute("target", target);
      if (className) {
        $a.setAttribute("class", className);
      }
      el.insertAdjacentElement("beforebegin", $a);
      $a.addEventListener("click", (e) => {
        if (prevent) {
          e.preventDefault();
        }
      });
      $a.appendChild(el);
    }
  }
};
export function register(app) {
  return Object.entries(directives).map(([name, config]) => {
    app.directive(name, config);
  });
}
export default directives;
